/**
 * Canonical matter status values + lifecycle helpers.
 *
 * Status moves through these phases:
 *
 *   In Progress
 *     ↓
 *   Awaiting Review                     (case manager review)
 *     ↓
 *   Awaiting Eli's final review         (set by LodgementGate when 100% approved)
 *     ↓
 *   Lodged with Home Affairs            (Eli lodged; awaiting decision)
 *     ↓
 *   Approved | Refused | Withdrawn      (terminal — moves matter to /matters/archived)
 *
 * Statuses are stored as plain text (no DB enum), so callers should always
 * use these constants instead of string literals.
 */

export const STATUS_IN_PROGRESS = 'In Progress';
export const STATUS_AWAITING_REVIEW = 'Awaiting Review';
export const STATUS_AWAITING_FINAL_REVIEW = "Awaiting Eli's final review";
export const STATUS_READY_FOR_LODGEMENT = 'Ready for lodgement';
export const STATUS_LODGED = 'Lodged with Home Affairs';
export const STATUS_APPROVED = 'Approved';
export const STATUS_REFUSED = 'Refused';
export const STATUS_WITHDRAWN = 'Withdrawn';

/**
 * Terminal statuses — matters in these states no longer appear on the main
 * /matters list; they're moved to /matters/archived.
 */
export const ARCHIVED_STATUSES: readonly string[] = [
  STATUS_APPROVED,
  STATUS_REFUSED,
  STATUS_WITHDRAWN,
];

export function isArchivedStatus(s: string): boolean {
  return ARCHIVED_STATUSES.includes(s);
}

/** Possible next statuses given the current one — drives the action buttons. */
export function nextStatusOptions(current: string): string[] {
  switch (current) {
    case STATUS_AWAITING_FINAL_REVIEW:
      return [STATUS_LODGED];
    case STATUS_LODGED:
      return [STATUS_APPROVED, STATUS_REFUSED, STATUS_WITHDRAWN];
    default:
      return [];
  }
}
